import { UserRoles } from 'types';
import { AppContext, IAppContext } from 'appState/appContext';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { useContext } from 'react';

interface IDefaultRestaurant {
	id: string;
	restaurantName: string | null;
}

export const useLoggedUserRestaurants = <T extends IDefaultRestaurant>(allRestaurants: T[]) => {
	const { loggedUser } = useContext<IAppContext>(AppContext);
	const showAllRestaurants = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);

	if (showAllRestaurants) {
		return allRestaurants;
	}

	const accessibleRestaurantIds = loggedUser.restaurants?.map((el) => el.id) || [];

	const intersectedRestaurants = allRestaurants.filter((el) => accessibleRestaurantIds.includes(el.id));

	return intersectedRestaurants;
};
